import { render } from "./CardHistoryDialog.vue?vue&type=template&id=70a171f5"
import script from "./CardHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CardHistoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__